import { useQuery } from "@tanstack/react-query";

import { getProfileFieldsMetadata } from "../api/userProfileApi";
import { userProfileKeys } from "../api/userProfileKeys";

export const useProfileFieldsMetadata = () =>
    useQuery({
        queryKey: userProfileKeys.fieldsMetadata(),
        queryFn: getProfileFieldsMetadata,
    });
